import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || '';
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || '';

// Check if credentials are available and valid
export const isSupabaseConfigured = !!(
  supabaseUrl && 
  supabaseAnonKey && 
  supabaseUrl.trim().startsWith('http')
);

// Create a simple client - let Supabase handle validation
export const supabase = isSupabaseConfigured
  ? createClient(supabaseUrl.trim(), supabaseAnonKey.trim())
  : createClient('https://placeholder.supabase.co', 'placeholder-key');

// Log configuration status
if (!isSupabaseConfigured) {
  console.warn('⚠️ Supabase not configured. Set REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_ANON_KEY.');
  console.warn('Current URL:', supabaseUrl || '(empty)');
  console.warn('Current Key:', supabaseAnonKey ? '(set but hidden)' : '(empty)');
}

